<template>
  <div>
    <NavBar />
    <div class="my-4">
      <a
        :href="stripeCustomerDashboardUrl"
        class="font-medium text-blue-600 dark:text-blue-500 hover:underline"
        target="_blank"
        >Go to billing panel</a
      >
    </div>
    <div class="my-4">
      <a
        v-if="store.paymentLink"
        :href="store.paymentLink"
        class="button-50 bg-black text-white mt-4 py-3 font-semibold text-base rounded hover:bg-gray-800 w-full"
        >Upgrade subscription</a
      >
    </div>
    <p class="my-4" v-if="store.usageLimit !== null">
      Usage: {{ store.usageCount }} /
      {{ store.usageLimit }}
    </p>
    <div class="my-6">
      <RouterLink
        :to="{ name: 'home' }"
        class="bg-transparent hover:bg-black text-black font-semibold hover:text-white py-1 px-4 text-sm border border-black hover:border-transparent rounded"
        >Generate diagram</RouterLink
      >
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useMainStore } from "@/store";

export default {
  name: "CustomerPanel",
  components: {
    NavBar,
  },
  setup() {
    const store = useMainStore();
    return { store };
  },
  computed: {
    stripeCustomerDashboardUrl() {
      return process.env.VUE_APP_STRIPE_CUSTOMER_DASHBOARD_URL;
    },
  },
};
</script>
